import styled from 'styled-components';

export const ContainerWrapper = styled.section`
    width: 100%;
    height: 100%;
    max-width: 1200px;
    margin: 0 auto;
    color: #3A3B3C;
    
    .header-style {
        padding: 0 20px;

        h1 {
            font-size: 50px;
            font-weight: bold;
            font-family: Poppins;
            margin-bottom: 0;
        }
    
        p {
            color: #3A3B3C;
            font-family: Poppins;
            font-weight: 400;
            font-size: 1.25em;
        }

    }

    @media(max-width: 411px) {
        .header-style {
            
            p {
                font-size: 16px;
            }
        }
    }

`;

export const ContainerCards = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(353px, 1fr));
    justify-content: center;
    column-gap: 2.5rem;
    row-gap: 4rem;
    padding: 4rem 20px;

    @media(max-width: 411px) {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }
`;

export const ButtonContainer = styled.div`
    margin-bottom: 5rem;
    display: flex;
    justify-content: center;
`;